import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'formdata-polyfill'
import Vue from 'vue'
import VueTheMask from 'vue-the-mask'

import formHeader from './components/formHeader'

import CashLanding from './CashLanding.vue'
import popupConditionsCredit from './components/popup-conditions-credit'
import popupHelp from './components/popup_help'

import cashScript from './cash'

$(document).ready(function () {
  $(".lazyload").each(function (i) {
    $(this).attr("src", $(this).attr("data-src"));
  });
  // cashScript.init();
});

Vue.use(VueTheMask);


Vue.component('cash-landing', CashLanding);
Vue.component('popup-conditions-credit', popupConditionsCredit);
Vue.component('popup-help', popupHelp);
Vue.component('form-header', formHeader);

Vue.directive('numericOnly', {

  bind: function (el) {
    el.addEventListener('input', function () {
      return el.validity.valid || (el.value = '');
    });

    // this prevents from typing non-number text, including "e".
    el.addEventListener('keypress', function (e) {
      let charCode = (e.which) ? e.which : e.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        e.preventDefault();
      } else {
        return true;
      }
    });
  }
});
Vue.directive('lettericOnly', {

  bind: function (el) {

    el.addEventListener('input', function (e) {
      return el.validity.valid || (el.value = '');
    });

    el.addEventListener('keyup', function (e) {

      let $input = $(e.target);
      let val = $input.val().replace(/[^а-щА-ЩЬьЮюЯяЇїІіЄєҐґ\s\'\-]/g, '');
      $input.val(val);
    });
  }


});
Vue.directive('autocomplete', {

  bind: function (el) {

    el.addEventListener('input', function (e) {
      return el.value = '';
    });

    el.addEventListener('keyup', function (e) {

      let $input = $(e.target);
      let val = $input.val().replace(/[^а-щА-ЩЬьЮюЯяЇїІіЄєҐґ\s\'\-]/g, '');
      $input.val(val);
    });
  }


});
Vue.directive('house', {

  bind: function (el) {

    el.addEventListener('input', function (e) {
      return el.validity.valid || (el.value = '');
    });

    el.addEventListener('change', function (e) {

      let $input = $(e.target);
      let val = $input.val().replace(/[^0-9-а-щА-ЩЬьЮюЯяЇїІіЄєҐґ\s\'\-]/g, '');
      $input.val(val);
    });
  }
});

Vue.directive('apartment', {

  bind: function (el) {

    el.addEventListener('input', function (e) {
      return el.validity.valid || (el.value = '');
    });

    el.addEventListener('change', function (e) {

      let $input = $(e.target);
      let val = $input.val().replace(/[^0-9-а-щА-ЩЬьЮюЯяЇїІіЄєҐґ,\s\'\-\/]/g, '');
      $input.val(val);
    });
  }
});

new Vue({
  el: '#usedcar-cash-landing-vue',
  data() {
    return {

    }
  },
  methods: {
    openConditions: function () {
      this.$refs.popupConditionsCredit.popupShow();
    },
    openPopupHelp: function () {
      this.$refs.popupHelp.popupShow();
    },
  },
  mounted: function () {
    document.addEventListener('keydown', function (e) {
      if (e.keyCode === 27) {
        $('.popup-all').hide();
      }
    });

    $(document).on('click', '.popup-container', function (e) {
      e.stopPropagation();
      if ($(e.target).find('.popup-vue').length > 0) {
        $('.popup-all').hide();
      };
    });
  }

});


